import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getFinInsuranceData = createAsyncThunk("api/employee-insurance/search?finance=1&query=", async (token, type) => {
    try {
        const response = await nodeinstance.get("/employee-insurance/search?finance=1&query=", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const FinInsuranceDataSlice = createSlice({
    name: "insurance",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFinInsuranceData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getFinInsuranceData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getFinInsuranceData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getFinInsuranceData };
export default FinInsuranceDataSlice.reducer;
